import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { polymorphicFactory, useProps } from '@coveord/plasma-mantine';
import { IconExternalLink } from '@coveord/plasma-react-icons';
import { Anchor } from '../anchor/Anchor.js';
import { useEmptyStateContext } from './EmptyStateContext.js';
var defaultProps = {
    icon: IconExternalLink
};
export var EmptyStateLink = polymorphicFactory(function(props) {
    var ctx = useEmptyStateContext();
    var _useProps = useProps('EmptyStateLink', defaultProps, props), IconName = _useProps.icon, children = _useProps.children, classNames = _useProps.classNames, className = _useProps.className, styles = _useProps.styles, style = _useProps.style, ref = _useProps.ref, others = _object_without_properties(_useProps, [
        "icon",
        "children",
        "classNames",
        "className",
        "styles",
        "style",
        "ref"
    ]);
    return /*#__PURE__*/ _jsxs(Anchor, _object_spread_props(_object_spread({
        ref: ref
    }, ctx.getStyles('link', {
        classNames: classNames,
        className: className,
        styles: styles,
        style: style
    }), others), {
        children: [
            /*#__PURE__*/ _jsx(IconName, {
                height: 16
            }),
            children
        ]
    }));
});
EmptyStateLink.displayName = 'EmptyState.Link';

//# sourceMappingURL=EmptyStateLink.js.map